import createIcon from "../createIcon";
export var HeartConfig = {
  displayName: "Heart",
  attrs: {
    fill: "currentColor"
  },
  css: {
    display: "inline-block",
    verticalAlign: "middle",
    overflow: "hidden",
    maxHeight: "100%",
    maxWidth: "100%",
    margin: "auto"
  },
  width: 24,
  height: 24,
  titleKey: "Heart-title",
  viewBox: "0 0 24 24",
  labelledby: "icon-title-Heart",
  body: [{
    type: "path",
    props: {
      fill: "none",
      d: "M13.207 6.207l-.5.5a.999.999 0 0 1-1.414 0l-.5-.5c-.754-.754-1.744-1.17-2.789-1.17s-2.039.416-2.799 1.172c-1.56 1.567-1.561 4.021.002 5.584L12 18.586l6.793-6.793c1.563-1.563 1.562-4.017-.002-5.588-1.51-1.503-4.072-1.507-5.584.002z",
      key: "k0"
    }
  }, {
    type: "path",
    props: {
      d: "M20.205 4.791a5.938 5.938 0 0 0-4.209-1.754A5.906 5.906 0 0 0 12 4.595a5.904 5.904 0 0 0-3.996-1.558 5.942 5.942 0 0 0-4.213 1.758c-2.353 2.363-2.352 6.059.002 8.412l7.332 7.332c.17.299.498.492.875.492a.99.99 0 0 0 .792-.409l7.415-7.415c2.354-2.353 2.355-6.049-.002-8.416zm-1.412 7.002L12 18.586l-6.793-6.793c-1.562-1.563-1.561-4.017-.002-5.584.76-.756 1.754-1.172 2.799-1.172s2.035.416 2.789 1.17l.5.5a.999.999 0 0 0 1.414 0l.5-.5c1.512-1.509 4.074-1.505 5.584-.002 1.563 1.571 1.564 4.025.002 5.588z",
      key: "k1"
    }
  }]
};
export default createIcon(HeartConfig);